import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { Tooltip, type TooltipProps } from '@mui/material';
import React from 'react';
import { Button } from 'react-bootstrap';

interface ButtonWithLoadingProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: (e: React.FormEvent) => void;
  style?: React.CSSProperties;
  tooltip?: Omit<TooltipProps, 'children'>;
  type?: 'button' | 'reset' | 'submit';
}

const ButtonWithLoading: React.FC<ButtonWithLoadingProps> = ({
  children,
  className,
  disabled,
  isLoading,
  onClick,
  style,
  tooltip,
  type = 'button',
}) => {
  const { t } = useTranslationWithPrefix('components.loader');

  return (
    <Tooltip placement={tooltip?.placement ?? 'top'} title={tooltip?.title}>
      <Button
        className={`loading-button align-self-stretch align-self-md-start ${className}`}
        disabled={(disabled ?? false) || isLoading}
        onClick={onClick}
        onTouchStart={onClick}
        style={style}
        type={type}
      >
        {isLoading ? (
          <div className="spinner-border text-primary spinner-border-sm" role="status">
            <span className="visually-hidden">{t('loading')}</span>
          </div>
        ) : null}
        <span className={isLoading ? 'visually-hidden' : 'block'}>{children}</span>
      </Button>
    </Tooltip>
  );
};

export default ButtonWithLoading;
